// src/components/quizzes/gameExit.js
//
// ONE way out of every game. Each game type used to work out its own "home"
// — some sent you to the dashboard, some to an old /topics/nc-1st-… page, a
// teacher could land on a student page. Now the game page
// (games/UniversalQuizGame.js) knows exactly which subject page you came
// from and every game asks it:
//
//   const leaveGame = useLeaveGame();
//   <button onClick={() => leaveGame()}>Return</button>
//
// It asks first ("You'll lose this game's progress") in a friendly popup.

import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FunPopup from "../common/FunPopup";

const Ctx = createContext(null);

/** The subject page this game was opened from. */
export const portalPathFromParams = (p = {}) =>
  p.state && p.grade && p.subject ? `/portal/${p.state}/${p.grade}/${p.subject}/${p.view === "educator" ? "educator" : "student"}` : "";

export const GameExitProvider = ({ returnPath, children }) => {
  const navigate = useNavigate();
  const [pop, setPop] = useState(null);
  const leave = useCallback(
    (opts = {}) => {
      const go = () => navigate(returnPath || "/dashboard");
      if (opts.ask === false) return go();
      return setPop({
        tone: "info",
        icon: "🚪",
        title: "Leave this game?",
        text: "If you leave now, this game's progress won't be saved.",
        yes: "Yes, leave",
        no: "Keep playing",
        onConfirm: go,
      });
    },
    [navigate, returnPath]
  );
  const value = useMemo(() => ({ leave, returnPath }), [leave, returnPath]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <FunPopup pop={pop} onClose={() => setPop(null)} />
    </Ctx.Provider>
  );
};

/** () => asks, then goes back to the right subject page. */
export const useLeaveGame = () => {
  const ctx = useContext(Ctx);
  const params = useParams();
  const navigate = useNavigate();
  return useCallback(
    (opts) => {
      if (ctx) return ctx.leave(opts);
      // outside the game page (shouldn't happen): best guess from the URL
      return navigate(portalPathFromParams(params) || "/dashboard");
    },
    [ctx, params, navigate]
  );
};
